import React, { useState, useEffect, useRef } from 'react';
import { string, shape, arrayOf } from 'prop-types';
import classNames from 'classnames';
import Image from '../Image';
import isIntersectionObserverDefined from '../../../utils/isIntersectionObserverDefined';

import './style.scss';

const VideoModal = ({
    imgSrc,
    pictureData = [],
    sourceInfo,
    subtitles,
    videoUrl,
    onOpen,
    className = '',
    loadBgImg = 'auto'
}) => {
    const wrapperRef = useRef(null);
    const modalRef = useRef(null);
    const modalHandle = useRef(null);
    const [modalImported, setModalImported] = useState(false);

    useEffect(() => {

        const initObserver = () => {
            if (!isIntersectionObserverDefined()) {
                fetchComponent();
                return;
            }

            const observeTarget = wrapperRef.current;
            const observer = new IntersectionObserver((entries) => {
                if (entries[0].intersectionRatio <= 0) {
                    return;
                }
                fetchComponent();
                observer.unobserve(observeTarget);
            });

            observer.observe(observeTarget);
        };

        const fetchComponent = async() => {
            const modal = await import(/* webpackChunkName: 'VideoModal' */'./Modal');
            modalRef.current = modal.default;
            setModalImported(true);
        };

        initObserver();

    }, []);

    const modalClassName = classNames('video-modal', className);
    const Modal = modalRef.current;

    return (
        <div className={modalClassName} ref={wrapperRef}>
            <div className="picture-wrapper" onClick={() => {
                modalHandle.current();
            }}>
                <picture>
                    {
                        pictureData.map(({ media, srcSet }) => (
                            <source key={media} media={media} srcSet={srcSet}/>
                        ))
                    }
                    <Image src={imgSrc} alt="logged_out_homepage.video_modal.image" loading={loadBgImg}/>
                </picture>
            </div>
            {modalImported && <Modal onOpen={onOpen}
                sourceInfo={sourceInfo}
                videoUrl={videoUrl}
                subtitles={subtitles}
                trigger={({ open }) => {
                    modalHandle.current = open;
                }}>
            </Modal>}
        </div>
    );
};

VideoModal.propTypes = {
    imgSrc: string,
    pictureData: arrayOf(
        shape({
            srcSet: string,
            media: string
        })
    ),
    subtitles: arrayOf(
        shape({
            src: string,
            srcLang: string,
            label: string
        })
    ),
    sourceInfo: shape({
        videoName: string,
        mixpanel: shape({
            pageName: string
        }),
        bigQuery: shape({
            pageName: string
        })
    }),
    videoUrl: string,
    className: string,
    loadBgImg: string
};

export default VideoModal;
